import React from 'react';

const authContext = React.createContext({
  isLoggedIn: false,
  login: () => {
    // do nothing.
  },
  logout: () => {
    // do nothing.
  },
});

export default authContext;
